<template>
    <div class="animated fadeIn">
        <b-row v-if="loading">
            <b-col md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-4"
                />
            </b-col>
        </b-row>
        <div v-else>
            <component-header
                ref="headerComp"
                title="Customer"
                :enableOnClickSearch="true"
                @reload-data="reloadData"
                @create-press="$router.push({ path: '/customers/create' })"
                createButtonText="Create Customer"
                :hasCreate="true"
                :hasback="false"
                :hasDropdown="false"
                :hasSearch="false"
            />
            <b-card class="card-wrap" border-variant="info">
                <div>
                    <b-table
                        style="border-radius: 12px"
                        :dark="dark"
                        :hover="hover"
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        responsive
                        id="my-table"
                        :items="customers"
                        :current-page="currentPage"
                        :per-page="perPage"
                        :filter="filter"
                        thead-class="header"
                        class="mt-3 tableRadius professional-stacked-table"
                        :busy="loading"
                        show-empty
                        :fields="customerColumns"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template slot="cell(action)" slot-scope="data">
                            <div class="action-buttons-inline">
                                <ActionButtonGroup
                                    showView
                                    showEdit
                                    @view="
                                        $router.push({
                                            name: 'ViewCustomer',
                                            params: { id: data.item._id },
                                        })
                                    "
                                    @edit="
                                        $router.push({
                                            name: 'EditCustomer',
                                            params: { id: data.item._id },
                                        })
                                    "
                                >
                                    <b-button
                                        class="button-circle mr-2"
                                        variant="primary"
                                        v-b-tooltip.hover
                                        title="Visitors"
                                        @click="openVisitors(data.item)"
                                    >
                                        <i class="fa fa-user"></i>
                                    </b-button>
                                    <b-button
                                        class="button-circle mr-2"
                                        style="background-color: #660099"
                                        v-b-tooltip.hover
                                        title="Ticket"
                                        @click="
                                            $router.push({
                                                name: 'RaiseTicket',
                                                params: {
                                                    id: data.item._id,
                                                    data: data.item,
                                                    customerData: customersList.find(
                                                        (cust) =>
                                                            cust._id === data.item._id,
                                                    ),
                                                },
                                            })
                                        "
                                    >
                                        <i class="fa fa-ticket"></i>
                                    </b-button>
                                    <b-button
                                        class="button-circle mr-2"
                                        variant="danger"
                                        v-b-tooltip.hover
                                        title="Customer Termination"
                                        @click="openTerminateModal(data.item._id)"
                                    >
                                        <i class="fa fa-close"></i>
                                    </b-button>
                                </ActionButtonGroup>
                            </div>
                        </template>
                        <template slot="cell(empty)">
                            <div v-if="loading" class="text-center">
                                <span><b>Loading...</b></span>
                            </div>
                            <div v-else class="text-center">
                                No data available.
                            </div>
                        </template>
                    </b-table>
                </div>
                <div style="float: right">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="customers.length"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
            </b-card>
        </div>
        <b-modal
            ref="terminateModal"
            hide-footer
            centered
            title="Terminate Customer"
            size="md"
            class="termination-modal"
        >
            <div class="termination-content">
                <h2 class="text-danger text-center mb-4">
                    This action can't be revert!
                </h2>
                <div class="input-section">
                    <label for="reason" class="text-muted text-left d-block">
                        Please provide the reason for termination:
                    </label>
                    <b-form-textarea
                        id="reason"
                        v-model="terminateReason"
                        rows="3"
                        class="reason-input"
                        placeholder="Enter the reason here"
                    ></b-form-textarea>
                </div>
            </div>
            <div class="modal-footer justify-content-center mt-4">
                <div v-if="isLoading" class="spinner-overlay">
                    <div class="spinner"></div>
                </div>
                <b-button variant="danger" @click="hideTerminateModal">
                    Cancel
                </b-button>
                <b-button variant="danger" @click="confirmTerminate">
                    Terminate
                </b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";
import ActionButtonGroup from "@/components/Common/ActionButtonGroup.vue";
export default {
    components: {
        ComponentHeader,
        AtomSpinner,
        ActionButtonGroup,
    },
    data() {
        return {
            loading: false,
            filter: "",
            perPage: 10,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            dark: false,
            sortBy: "createdAt",
            sortDesc: true,
            fixed: false,
            currentPage: 1,
            loading: true,
            context: "Add",
            terminateReason: "",
            customerIdToTerminate: null,
            isLoading: false,
            customerColumns: [
                {
                    key: "customerNo",
                    label: "Customer Number",
                    thClass: "customer-col-number",
                    tdClass: "customer-col-number",
                    thStyle: { width: "18%" },
                },
                {
                    key: "name",
                    label: "Name",
                    thClass: "customer-col-name",
                    tdClass: "customer-col-name",
                    thStyle: { width: "20%" },
                },
                {
                    key: "email",
                    label: "Email",
                    thClass: "customer-col-email",
                    tdClass: "customer-col-email",
                    thStyle: { width: "34%" },
                },
                {
                    key: "action",
                    label: "Action",
                    thClass: "customer-col-action",
                    tdClass: "customer-col-action",
                    thStyle: { width: "28%" },
                },
            ],
        };
    },
    computed: {
        ...mapState({
            customersList: (state) => state.onboardCustomer.customerData,
        }),
        customers() {
            const data = this.customersList;
            if (!Array.isArray(data) || data.length === 0) return [];
            return data.map((obj) => ({
                _id: obj._id,
                customerNo: obj?.customerNo,
                email: obj?.authentication?.email,
                phone: obj?.authentication?.phone,
                name: `${obj.name.first} ${obj.name.last}`,
            }));
        },
    },
    methods: {
        reloadData() {
            this.fetchCustomerlist();
        },
        async fetchCustomerlist() {
            this.loading = true;
            try {
                await this.$store.dispatch(
                    "onboardCustomer/fetchOnboardCustomerList",
                );
            } finally {
                this.loading = false;
            }
        },
        openTerminateModal(customerId) {
            this.customerIdToTerminate = customerId;
            this.terminateReason = "";
            this.$refs.terminateModal.show();
        },
        openVisitors(customer) {
            this.$router.push({
                name: "MyList",
                params: {
                    id: customer._id,
                    listData: this.customersList.find(
                        (cust) => cust._id === customer._id,
                    ),
                },
            });
        },
        hideTerminateModal() {
            this.$refs.terminateModal.hide();
        },
        async confirmTerminate() {
            this.isLoading = true;
            if (!this.terminateReason) {
                this.isLoading = false;
                this.$toasted.error("Please provide a reason for termination");
                return;
            }
            const selectedCustomer = this.customersList.find(
                (cust) => cust._id === this.customerIdToTerminate,
            );
            const payload = {
                id: this.customerIdToTerminate,
                customerId: this.customerIdToTerminate,
                reason: this.terminateReason,
                description: this.terminateReason,
                subject: "Customer termination",
                custom: {
                    reason: this.terminateReason,
                },
                customerNo: selectedCustomer?.customerNo,
            };
            try {
                await this.$store.dispatch(
                    "onboardCustomer/terminateCustomerAction",
                    payload,
                );
                this.isLoading = false;
                this.$toasted.success("Customer Terminated Successfully");
                this.hideTerminateModal();
                this.reloadData();
            } catch (error) {
                console.error("Error during termination:", error);
                const apiMessage =
                    error?.response?.data?.message ||
                    error?.response?.data?.error ||
                    error?.message ||
                    "Unknown error";
                this.$toasted.error("Termination Failed: " + apiMessage);
            } finally {
                this.isLoading = false;
            }
        },
    },
    mounted() {
        this.fetchCustomerlist();
    },
};
</script>
<style>
.action-buttons-inline .button-circle {
    flex-shrink: 0;
    margin-right: 0 !important;
    margin-left: 0 !important;
    width: 32px !important;
    height: 32px !important;
    min-width: 32px !important;
    min-height: 32px !important;
    padding: 0 !important;
    border-radius: 50% !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    line-height: 1 !important;
}

.termination-modal {
    max-width: 500px;
    border-radius: 15px;
    background-color: #f7f8fc;
    padding: 20px;
}
.termination-content {
    text-align: center;
}
.reason-input {
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 10px;
    margin-top: 10px;
    font-size: 1rem;
}
.input-section {
    margin-top: 20px;
}
label {
    display: block;
    margin-bottom: 8px;
    text-align: left;
}
.modal-footer {
    display: flex;
    justify-content: center;
}
.modal-footer .btn {
    width: 150px;
    margin: 0 10px;
}
.b-modal {
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 12px;
}
.b-modal-header {
    border-bottom: none;
    text-align: center;
}
.b-modal-footer {
    border-top: none;
}
.b-modal-body {
    padding: 20px;
}
.modal-title {
    color: #0f0e0e;
    text-align: center;
}
.spinner-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
}
.spinner {
    border: 6px solid rgba(0, 0, 0, 0.1);
    border-left-color: #000;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
